import Axios from '@/Axios'
import axios from 'axios'

class WorkAllocationFormService {
    async getWorkAllocation(name) {
        console.log('name', name)
        return await Axios.get('wms.wms.api.work_allocation_form.get_work_allocation_data', { params: { name } })
    }
    async

    async getChartStatus(search) {
        return await Axios.get('wms.wms.api.work_allocation_tab.get_chartstatus_options?search=' + search)
    }
    async updatePriority(priority, name) {
        return await Axios.post('wms.wms.api.work_allocation_tab.update_priority', {
            priority: priority,
            name: name,
        })
    }
    async updateWorkAllocation(data) {
        return await Axios.patch('wms.wms.api.work_allocation_form.update_work_allocation_data', data)
    }
    async getCategory(name, category) {
        console.log('data', name, category)
        return await Axios.get('wms.wms.api.work_allocation_form.get_category_sub_category', { params: { name: name, category: category } })
    }

    async getSubCategory() {
        return await Axios.get('wms.wms.api.work_allocation_form.get_subcategory')
    }

    async getFollowupStatus() {
        return await Axios.get('wms.wms.api.work_allocation_form.get_followup_status')
    }
    async getActions(user, form_data) {
        return await Axios.get('wms.wms.api.user_action.get_user_actions', { params: { user: user, form_data: JSON.stringify(form_data) } })
    }
}
export default new WorkAllocationFormService()
